import React, { Fragment } from 'react';

import { FacetsLeft } from './facets/FacetsLeft/FacetsLeft';
import { ManufacturersFacet } from './facets/ManufacturersFacet/ManufacturersFacet';
import { Results } from './Results/Results';
import { Search } from './Search/Search';
import { Pagination } from './Pagination/Pagination';
import { ServerErrors } from './ServerErrors/ServerErrors';
import { Sorting } from './Sorting/Sorting';
import { formatString } from '../../assets/js/utils/formatString';
import { handleGtmSearchEvent } from '../../assets/js/utils/gtmSearch';

class SearchFilterResult extends React.Component {
    constructor(props) {
        super(props);

        const { searchResponse, pageData } = this.props;

        this.state = {
            searchResponse: searchResponse,
            searchTerm: searchResponse.searchTerm,
            submittedSearchTerm: searchResponse.searchTerm,
            pageNr: searchResponse.pageNr,
            pagePath: searchResponse.pagePath,
            sortOrder: pageData.sortOrder,
            facetTrigger: false,
        };
    }

    componentDidMount() {
        this.historyReplace();

        if (typeof window !== 'undefined') {
            window.onpopstate = () => {
                const { historyData } = history.state;

                if (history.state !== null && historyData !== null) {
                    this.setState({
                        pageNr: historyData.pageNr,
                        searchTerm: historyData.searchTerm,
                        submittedSearchTerm: historyData.submittedSearchTerm,
                        searchResponse: historyData.searchResponse,
                    });
                }
            };
        }
    }

    historyPush = () => {
        const { searchTerm, submittedSearchTerm, searchResponse, pageNr } = this.state;

        history.pushState(
            {
                historyData: {
                    searchTerm: searchTerm,
                    submittedSearchTerm: submittedSearchTerm,
                    searchResponse: searchResponse,
                    pageNr: pageNr,
                },
            },
            '',
            `${searchResponse.pagePath}`,
        );
    };

    historyReplace = () => {
        const { searchTerm, submittedSearchTerm, searchResponse, pageNr } = this.state;

        history.replaceState(
            {
                historyData: {
                    searchTerm: searchTerm,
                    submittedSearchTerm: submittedSearchTerm,
                    searchResponse: searchResponse,
                    pageNr: pageNr,
                },
            },
            '',
            `${searchResponse.pagePath}`,
        );
    };

    handleSortingChange = (sortingItem) => {
        this.setState({ sortOrder: sortingItem }, () => this.handlePagination(1));
    };

    handleFacetChange = (facetId, facetType, facetItem) => {
        if (facetType === 'checkbox' || facetType === 'manufacturers') {
            facetItem.value = !facetItem.value;
        }

        if (facetType === 'radio') {
            const { facets } = this.state.searchResponse;
            const thisFacet = facets.find((facet) => facet.facetId === facetId);
            thisFacet.items.forEach((item) => (item.value = false));
            facetItem.value = true;
        }

        this.handlePagination(1);
    };

    toggleFacetTrigger = (e) => {
        e.preventDefault();
        document.body.classList.toggle('overflow-hidden');

        this.setState({
            facetTrigger: !this.state.facetTrigger,
        });
    };

    handleSearchChange = (e) => {
        this.setState({ searchTerm: e.target.value });
    };

    handleClearSearch = (e) => {
        e.preventDefault();

        this.setState(
            {
                searchTerm: '',
                pageNr: 1,
            },
            this.handleDataReq,
        );
    };

    handleSearchSubmit = (e) => {
        e.preventDefault();
        
        const { searchTerm } = this.state;
        
        handleGtmSearchEvent('search', searchTerm)
        
        this.setState(
            {
                submittedSearchTerm: searchTerm,
                pageNr: 1,
            },
            this.handleDataReq,
        );
    };

    handlePagination = (item) => {
        this.setState({ pageNr: item }, this.handleDataReq);
    };

    handleDataReq = () => {
        const { endPointUrl, pageData } = this.props;
        const { searchResponse, searchTerm, pageNr, pagePath, sortOrder } = this.state;

        let facets = null;
        let transferableFilters = null;

        if (searchResponse != null) {
            facets = searchResponse.facets;
            transferableFilters = searchResponse.transferableFilters;
        }

        fetch(endPointUrl, {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                transferableFilters: transferableFilters,
                searchTerm: searchTerm,
                facets: facets,
                pageNr: pageNr,
                pagePath: pagePath,
                itemsPerPage: pageData.itemsPerPage,
                sortOrder: sortOrder,
            }),
        })
            .then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json();
                } else {
                    console.log('Something went wrong');
                }
            })
            .then((json) => {
                const searchResponse = json;

                this.setState(
                    () => ({
                        searchResponse: { ...searchResponse },
                        pagePath: searchResponse.pagePath,
                        pageNr: searchResponse.pageNr,
                    }),
                    () => this.historyPush(),
                );
            })
            .catch((err) => console.log(err));
    };

    render() {
        const {
            pageData,
            resourcedTexts,
            showSearchResultsTitle,
            showNrOfResults,
            showSearch,
            showFacetsLeft,
            showSorting,
            showPagination,
            viewType,
        } = this.props;

        const { searchResponse, searchTerm, submittedSearchTerm, sortOrder, facetTrigger, pageNr } =
            this.state;

        const { totalResults, errors, numberOfPages } = searchResponse;
        const showThePagination = showPagination && numberOfPages > 1;

        return (
            <div className="search-filter-result">
                {searchResponse && (
                    <>
                        {showSearchResultsTitle && (
                            <h1 className="sfr__title">
                                {pageData.useTitleFormat
                                    ? submittedSearchTerm
                                        ? formatString(resourcedTexts.titleSearchResultsForFormat, [
                                              submittedSearchTerm,
                                              pageData.title,
                                          ])
                                        : formatString(resourcedTexts.titleSearchResultFormat, [
                                              pageData.title,
                                          ])
                                    : pageData.title}
                            </h1>
                        )}

                        <section className="sfr__wrapper">
                            {errors !== null && errors.length !== 0 && (
                                <ServerErrors resourcedTexts={resourcedTexts} errors={errors} />
                            )}

                            <Fragment>
                                <div className="sfr__wrapper-content">
                                    {showFacetsLeft && (
                                        <div className="sfr__left-container">
                                            <FacetsLeft
                                                {...searchResponse}
                                                onFacetChange={this.handleFacetChange}
                                                resourcedTexts={resourcedTexts}
                                                facetTrigger={facetTrigger}
                                                toggleFacetTrigger={this.toggleFacetTrigger}
                                                totalResults={totalResults}
                                            />
                                        </div>
                                    )}

                                    <div className="sfr__right-container">
                                        <div className="sfr__right-container-top">
                                            {showNrOfResults && (
                                                <div className="sfr__nr-of-results" role="status">
                                                    <strong>{totalResults}</strong>{' '}
                                                    {resourcedTexts.numberOfResults}
                                                </div>
                                            )}

                                            {showFacetsLeft && (
                                                <button
                                                    type="button"
                                                    className="button sfr__mobile-facets-toggle"
                                                    onClick={this.toggleFacetTrigger}
                                                >
                                                    {resourcedTexts.filterButton}
                                                </button>
                                            )}

                                            {showSorting && (
                                                <Sorting
                                                    resourcedTexts={resourcedTexts}
                                                    sortOptions={pageData.sortOptions}
                                                    onSorting={this.handleSortingChange}
                                                    sortOrder={sortOrder}
                                                />
                                            )}

                                            {showSearch && (
                                                <Search
                                                    {...searchResponse}
                                                    onChange={this.handleSearchChange}
                                                    onClearSearch={this.handleClearSearch}
                                                    onSubmit={this.handleSearchSubmit}
                                                    searchTerm={searchTerm}
                                                    resourcedTexts={resourcedTexts}
                                                />
                                            )}
                                        </div>

                                        <ManufacturersFacet
                                            {...searchResponse}
                                            onFacetChange={this.handleFacetChange}
                                            resourcedTexts={resourcedTexts}
                                        />

                                        <Results
                                            {...searchResponse}
                                            searchTerm={searchResponse.searchTerm}
                                            resourcedTexts={resourcedTexts}
                                            viewType={viewType}
                                        />

                                        {showThePagination && (
                                            <Pagination
                                                {...searchResponse}
                                                key={searchResponse.totalResults}
                                                resourcedTexts={resourcedTexts}
                                                numberOfPages={numberOfPages}
                                                itemsPerPage={pageData.itemsPerPage}
                                                pageNr={pageNr}
                                                handlePagination={this.handlePagination}
                                            />
                                        )}
                                    </div>
                                </div>
                            </Fragment>
                        </section>
                    </>
                )}
            </div>
        );
    }
}

export { SearchFilterResult };
